module.exports = __webpack_public_path__ + "static/sofia-002-1ab4dd2f40b64457498e7f82b448d75d.jpg";